import React from 'react';
import { PaymentMethod } from '../types/payment';

interface PaymentMethodsProps {
  selectedMethod: PaymentMethod;
  onMethodChange: (method: PaymentMethod) => void;
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({ selectedMethod, onMethodChange }) => {
  const methods = [
    { id: 'pix' as PaymentMethod, icon: 'fas fa-qrcode', label: 'PIX' },
    { id: 'boleto' as PaymentMethod, icon: 'fas fa-barcode', label: 'Boleto/PIX' },
    { id: 'credit-card' as PaymentMethod, icon: 'far fa-credit-card', label: 'Cartão de Crédito' }
  ];

  return (
    <div className="payment-methods">
      {methods.map(method => (
        <div
          key={method.id}
          className={`payment-method ${selectedMethod === method.id ? 'active' : ''}`}
          onClick={() => onMethodChange(method.id)}
        >
          <i className={method.icon}></i>
          <span>{method.label}</span>
        </div>
      ))}
    </div>
  );
};

export default PaymentMethods;